const endpoints = {
  smsSchedule: "/messages/schedules",
  smsCampaigns: "/messages/campaigns",
  // priceSchedule: "/price_schedule",
  priceSchedule: "/sms/send",
  voiceCampaigns: "/voice_campaigns",
  groups: "/groups",

  prices: "/prices",
};
export default endpoints;

export const messagingEndpoints = {
  smsSend: "/sms/send",
  smsSchedule: "/sms/schedule",
  smsSendToGroup: "/sms/send-to-group",
  smsReports: "/sms/reports",
  callsInitiate: "/calls/initiate",
  callsSchedule: "/calls/schedule",
  callsInitiateToGroup: "/calls/initiate-to-group",
  callsScheduleToGroup: "/calls/schedule-to-group",
  callsReports: "/calls/reports",
  callsResend: "/calls/resend",
  senderId: "/sender-id",
  balance: "/balance",
  balanceTransactions: "/balance/transactions",
  balanceTopUp: "/balance/top-up",
  fileUpload: "/files/upload",
  apiKeys: "/api-keys",
  smsRates: "/sms/estimate",
  callsEstimate: "/calls/estimate",
  smsResendByCampaign: "/sms/resend-by-campaign",
  callsResendByCampaign: "/calls/resend-by-campaign",
  // priceSchedule: "/price_schedule",
  priceSchedule: "/sms/send",
  weatherCost: "/weather/cost",
  weatherSchedule: "/weather/schedule",
  weatherCampaigns: "/weather/campaigns",
  weatherCampaignReport: (id) => `/weather/campaigns/${id}/report`,
};

export const peopleEndpoints = {
  groupPersons: (groupId) => `/groups/${groupId}/persons`,
  groupPerson: (groupId, personId) => `/groups/${groupId}/persons/${personId}`,
  contacts: "/groups",
  fileUpload: "/person-uploads",
  personUploads: "/person-uploads",
};

export const contentEndpoints = {
  commodities: "/commodities",
  markets: "/markets",
};
